import { effect, signal } from "@preact/signals";
import { showSideBar } from "./config";

const screenshotDataURL = signal<string | null>(null);
const showScreenshotModal = signal<boolean>(false);

effect(() => {
    showScreenshotModal.value = !!screenshotDataURL.value;

    if (showScreenshotModal.value) {
        showSideBar.value = false;
    }
});

export { screenshotDataURL, showScreenshotModal };
